import React from 'react'
import { Box, Typography } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CuestionarioHistoricos } from './commons/CuestionarioHistoricos';
import { LineChart } from './LineChart';
import { HistoricoCuestionarioPerfilEmpresarial } from './HistoricoCuestionarioPerfilEmpresarial';
import colors from "../theme/colors";

export const AccordionPerfilEmpresarial = ({ PerfilEmpresarial }) => {
    return (
        <Box sx={{width: '100%'}}>
            <Accordion sx={{ marginBottom: '1em', boxShadow: 'none' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fontSize: "2.5rem", color: colors.textLink }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{ backgroundColor: colors.bgPrimaryLight, borderRadius: '8px' }}
                >
                    <HistoricoCuestionarioPerfilEmpresarial PerfilEmpresarial={PerfilEmpresarial} />
                </AccordionSummary>
                <AccordionDetails sx={{ marginBottom: '1em' }}>
                    {PerfilEmpresarial?.cuestionarios?.length > 0 && (
                        <Box sx={{ height: "400px" }}>
                            <LineChart cuestionarios={PerfilEmpresarial?.cuestionarios} />
                        </Box>
                    )}
                    <Box sx={{ marginTop: "30px" }} >
                        <CuestionarioHistoricos cuestionarios={PerfilEmpresarial?.cuestionarios} />
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}
